'use strict';

(function () {
  'use strict';

  angular.module('msOnboarding').controller('SsoCtrl', SsoCtrl);

  SsoCtrl.$inject = ['$stateParams', '$sessionStorage', 'authenticationSvc', 'loadingScreenSvc', 'onboardingRouter', 'ssoAuthView'];

  function SsoCtrl($stateParams, $sessionStorage, authenticationSvc, loadingScreenSvc, onboardingRouter, ssoAuthView) {
    var vm = this;
    vm.ssoAuthView = ssoAuthView;

    _init();

    function _init() {
      var orgName = _resolveOrgNameFromUser($sessionStorage.user);
      loadingScreenSvc.createLoadingScreen(orgName, function () {});

      if ($sessionStorage.user) {
        onboardingRouter.goToNextStep($stateParams);
        return;
      }

      authenticationSvc.ssoLogin(vm.ssoAuthView).then(_onSuccess, function (err) {
        loadingScreenSvc.removeLoadingScreen();

        if ($stateParams.mergeDisabled && err.data.errorCode === 'USER_ALREADY_EXISTS') {
          onboardingRouter.navigateSsoUniqueEmail({ error: err.data });
          return;
        }
        onboardingRouter.ssoMapLoginError(err);
      });
    }

    function _onSuccess(resp) {
      var user = resp.data.response;
      var orgName = _resolveOrgNameFromUser(user);

      // Remove standard login step - instead use sso login
      onboardingRouter.removeLoginStep();
      //both returning and new users just go to the next required step
      if (vm.ssoAuthView.attributesView.redirectUrl) {
        $sessionStorage.redirectUrl = vm.ssoAuthView.attributesView.redirectUrl;
      }

      loadingScreenSvc.createLoadingScreen(orgName, onboardingRouter.goToNextStep);
    }

    function _resolveOrgNameFromUser(user) {
      return user && user.organization && user.organization.name ? user.organization.name : 'myStrength';
    }
  }
})();